import { Component } from "react";
import { getMachineFromBarcode } from "../../backend/machines";
import { withRouter } from "react-router-dom";
import { getUser } from "../../backend/storage";
import View from "./view";
import { notify } from "../../backend";

class ScannerScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      watching: true
    };

    this._scanBarcode = this._scanBarcode.bind(this);
  }

  async componentDidMount() {
    this.setState({ user: await getUser() });
  }

  render() {
    return View.call(this);
  }

  async _scanBarcode({ codeResult }) {
    const { user } = this.state;

    this.setState({ watching: false, codeResult });
    const barcode = codeResult.code;
    if (barcode) {
      try {
        let { id } = await getMachineFromBarcode(barcode);
        if (id) {
          this.props.history.push(
            user.type.id === 3
              ? `/machine-history/${id}`
              : `/machine-form/${id}`
          );
        }
      } catch (error) {
        notify("Could not find machine for that barcode", "error");
        this.setState({ watching: true });
      }
    }
  }
}

export default withRouter(ScannerScreen);



// WEBPACK FOOTER //
// ./src/screens/scanner-screen/index.js